(() => {
  const labels = document.currentScript.dataset;
  const watched = new WeakSet();
  function attach() {
    const widgets = document.querySelectorAll('.jdgm-review-widget');
    widgets.forEach((widget) => {
      if (watched.has(widget)) return;
      watched.add(widget);
      const translate = () => {
        const label = widget.querySelector('.jm-no-reviews-state') ? labels.noReviews : labels.noResults;
        widget.querySelectorAll('.jdgm-empty-state p').forEach((paragraph) => {
          const text = paragraph.textContent.trim();
          if (['No items found', labels.noReviews, labels.noResults].includes(text) && text !== label) {
            paragraph.textContent = label;
          }
        });
      };
      new MutationObserver(translate).observe(widget, { childList: true, subtree: true, characterData: true });
      translate();
    });
    return widgets.length > 0;
  }
  if (!attach()) {
    const mountObserver = new MutationObserver(() => {
      if (attach()) mountObserver.disconnect();
    });
    mountObserver.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', attach);
})();
